module.exports = __webpack_public_path__ + "static/media/board-Onyka_Barrett-Scott.eaac2ab6.jpg";